import { apiClient } from "../api/apiClient";
const BASE = "settlement/get-claims";

export const settlementClaimsService = {
  getClaims: (params) => apiClient.get(BASE, params),
};